export default __webpack_public_path__ + "static/2000-github-stars-971d1c3d0b436606ebdd4b62e16552b8.jpeg";